import { render } from "./DefaultLayout.vue?vue&type=template&id=5eef788a"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\radoslaw\\Documents\\PhpStorm\\sentimentapp_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__